import React, { useState } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Dashboard from '../pages/Dashboard';
import Events from '../pages/Events';
import CreateEvent from '../pages/CreateEvent';
import ManageEvent from '../pages/ManageEvent';
import Contests from '../pages/Contests';
import CreateContest from '../pages/CreateContest';
import ContestSubmissions from '../pages/ContestSubmissions';
import EditContest from '../pages/EditContest';
import CheckInScanner from '../pages/CheckInScanner';
import Attendees from '../pages/Attendees';
import StaffManagement from '../pages/StaffManagement';
import PromoCodes from '../pages/PromoCodes';
import Settings from '../pages/Settings';
import Payouts from '../pages/Payouts';

const DashboardLayout = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="flex h-screen overflow-hidden bg-slate-50 text-slate-900 font-sans">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden relative bg-slate-50">
        <Header toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} />

        <main className="flex-1 overflow-y-auto p-4 md:p-8 scroll-smooth bg-slate-50">
          <div className="max-w-7xl mx-auto pb-20">
            <Switch>
              <Route exact path="/app" component={Dashboard} />

              {/* Events */}
              <Route exact path="/app/events" component={Events} />
              <Route exact path="/app/create" component={CreateEvent} />
              <Route exact path="/app/events/:id" component={ManageEvent} />
              <Route exact path="/app/events/:id/manage" component={ManageEvent} />

              {/* Contests */}
              <Route exact path="/app/contests" component={Contests} />
              <Route exact path="/app/contests/create" component={CreateContest} />
              <Route exact path="/app/contests/:id/submissions" component={ContestSubmissions} />
              <Route exact path="/app/contests/:id/edit" component={EditContest} />

              {/* Payouts, Attendees, Scanner, Staff & Promo */}
              <Route exact path="/app/payouts" component={Payouts} />
              <Route exact path="/app/attendees" component={Attendees} />
              <Route exact path="/app/tickets" component={Attendees} />
              <Route exact path="/app/checkin" component={CheckInScanner} />
              <Route exact path="/app/staff" component={StaffManagement} />
              <Route exact path="/app/promocodes" component={PromoCodes} />
              <Route exact path="/app/settings" component={Settings} />

              <Redirect to="/app" />
            </Switch>
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
